<template>
  <main id="main">
    <CampaignDtlForm :campaignSeq = campaignSeq />
  </main>
</template>
<script>
import CampaignDtlForm from '@/components/campaign/CampaignDtlForm.vue';
export default {
  props: {
    campaignSeq: {
      type: String,
      required: true
    },
  },
  components: {
    CampaignDtlForm
  }
}
</script>
<style lang="">

</style>